export function transString(str: string) {
  let translatedStr = "";

  for (let i = 0; i < str.length; i++) {
    if (str[i] === "-") {
      translatedStr += str[++i].toUpperCase();
    } else {
      translatedStr += str[i];
    }
  }

  return translatedStr;
}

export function formatTime(time: number) {
  const days = Math.floor(time / 3600 / 24);
  const hours = Math.floor(time / 3600) % 24;
  const minutes = Math.floor((time % 3600) / 60);
  const seconds = time % 60;

  return {
    days: `${days < 9 ? "0" : ""}${days}`,
    hours: `${hours < 9 ? "0" : ""}${hours}`,
    minutes: `${minutes < 9 ? "0" : ""}${minutes}`,
    seconds: `${seconds < 9 ? "0" : ""}${seconds}`,
  };
}

export function formatNumber(num: number) {
  return num.toString().padStart(2, "0");
}

export function getFormatedDate(date: string) {
  const [year, month, day] = date.split("-").map((num) => Number(num));
  return new Date(year, month - 1, day);
}

export function formatDate(date: Date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
